import SiteLink from "common/ui/SiteLink";
import React from "react";
import "./Footer.scss";
import { useSelector } from "react-redux";
import IAppStore from "./IAppStore";
import { localizeCommon as localize } from "features/localization/localizeService";
import Merchant from "domain/merchant";

const Footer: React.FC<any> = () => {
  const activeMerchant = useSelector((m: IAppStore) => m.userState.activeMerchant);
  const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);
  
  return <FooterTemplate activeMerchant={activeMerchant} isCustomer={isCustomer} />
};

export interface FooterTemplateProps {
  activeMerchant: Merchant;
  isCustomer: boolean;
}

export const FooterTemplate: React.FC<FooterTemplateProps> = React.memo(props => {
  const year = (new Date()).getFullYear();
  return (
    <footer>
        <div className="container-fluid mb-2">          
        <div className="row">
          <div className="col-md-10 col-xs-12 link-group">
              <ul className="list-inline links">
                  <li className="list-inline-item">{localize("Footer_Label_Copyright", {year: year, company: 'StoneX Group Inc.'})}</li>
                  <li className="list-inline-item"><a href="https://stonex.com/privacy-notice/">{localize("Footer_Link_Privacy")}</a></li>
                  <li className="list-inline-item"><a href="https://stonex.com/terms-of-use/">{localize("Footer_Link_Terms")}</a></li>
                  <li className="list-inline-item"><SiteLink.Disclaimer>{localize("Footer_Link_Disclaimer")}</SiteLink.Disclaimer></li>
                  <li className="list-inline-item"><a href="https://stonex.com">StoneX.Com</a></li>
              </ul>
              {
                props.isCustomer && 
                <ul className="list-inline mobile-app-group">
                  {props.activeMerchant?.playStoreUrl && <li className="list-inline-item"><a href={props.activeMerchant.playStoreUrl} target="_blank"><img width="140" height="40" src="/images/google-play-badge.png" alt="Play Store" /></a></li>}
                  {props.activeMerchant?.appStoreUrl && <li className="list-inline-item"><a href={props.activeMerchant.appStoreUrl} target="_blank"><img src="/images/app-store-badge.svg" alt="App Store" /></a></li>}
                </ul>
              }
              
          </div>
          <div className="col-md-2 col-xs-4 social-media-links">
              <a className="btn btn-flat float-right" href="https://www.twitter.com/StoneX_Official"><i className="fa fa-twitter"></i></a>
              <a className="btn btn-flat float-right" href="https://www.linkedin.com/company/stonex-group-inc"><i className="fa fa-linkedin"></i></a>
              <a className="btn btn-flat float-right" href="https://www.youtube.com/channel/UC5a8rKMaVmaViwJvmCMl-1Q/featured"><i className="fa fa-youtube"></i></a>
          </div>
        </div>
        <div className="row">
          <div className = "col-md-12 col-xs-12">
            <p>
              {localize("Footer_Label_Futures")}
            </p>
          </div> 
        </div> 
        </div>
    </footer>
  );
})

export default Footer;